import React from 'react'

//Components.
import CurrentUserNavbar from '../../../../components/navigation-bars/currentUser-navbar/CurrentUserNavbar'

//Dependencies.
import { Outlet } from 'react-router-dom'

//Functions.
  //Callbacks.
  import { loggedInUser } from '../../../../slices/allUsersSlice'
  //Slice.
  import { useSelector } from 'react-redux';

import './MemberHomePage.styles.css'


const MemberHomePage = () => {
   const currentUser = useSelector(loggedInUser);
   const { username, imageLink } = currentUser;

   return (
      <div className='px-3'>
         <CurrentUserNavbar />
         <div style={{ display: 'flex', justifyContent: 'center' }}>
            <h1>Welcome to your homepage, { imageLink ? <img src={imageLink} width="5%" alt='user home image' /> : "" } <span style={{color: 'firebrick'}}>{ username }</span>!!!</h1>
         </div>
         <Outlet />
      </div>
   )
}

export default MemberHomePage 